var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReferralStep3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 72,
    height: 72,
    rx: 36,
    fill: "url(#paint0_linear_316_893)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.8781 29.1098C24.3719 29.1098 26.5375 30.4223 27.7844 32.3254L38.9406 26.1566C38.4156 25.1723 38.0875 23.991 38.0875 22.8098C38.0219 18.9379 41.1719 15.8535 44.9781 15.8535C48.7844 15.8535 52 18.9379 52 22.8098C52 26.6816 48.85 29.766 45.0437 29.766C43.2719 29.766 41.6313 29.1098 40.3844 27.9941L28.6375 34.4254C28.7688 34.9504 28.8344 35.4754 28.8344 36.066C28.8344 37.5098 28.4406 38.8223 27.6531 39.8723L38.2844 47.2223C39.1375 44.3348 41.8281 42.2348 44.9781 42.2348C48.85 42.2348 51.9344 45.3848 51.9344 49.191C51.9344 52.9973 48.7844 56.1473 44.9781 56.1473C41.3688 56.1473 38.35 53.3254 38.0219 49.7816L26.0781 41.5129C24.8969 42.4316 23.4531 42.9566 21.8125 42.9566C17.9406 42.9566 14.8563 39.8066 14.8563 36.0004C14.8563 32.1941 18.0063 29.1098 21.8781 29.1098ZM44.9781 27.4691C47.5375 27.4691 49.6375 25.3691 49.6375 22.8098C49.6375 20.2504 47.5375 18.1504 44.9781 18.1504C42.4187 18.1504 40.3188 20.2504 40.3188 22.8098C40.3188 25.3691 42.4187 27.4691 44.9781 27.4691ZM44.9781 53.916C47.5375 53.916 49.6375 51.816 49.6375 49.2566C49.6375 46.6973 47.5375 44.5973 44.9781 44.5973C42.4187 44.5973 40.3188 46.6973 40.3188 49.2566C40.3188 51.816 42.4187 53.916 44.9781 53.916ZM21.8781 40.7254C24.4375 40.7254 26.5375 38.6254 26.5375 36.066C26.5375 33.5066 24.4375 31.4066 21.8781 31.4066C19.3188 31.4066 17.2188 33.5066 17.2188 36.066C17.1531 38.6254 19.2531 40.7254 21.8781 40.7254Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_316_893",
    x1: 36,
    y1: 0,
    x2: 36,
    y2: 72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00F981"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0056FB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferralStep3);
export default __webpack_public_path__ + "static/media/Referral-Step-3.863334cbd302e61caf01932de5318683.svg";
export { ForwardRef as ReactComponent };